function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 3px;\n    height: 12px;\n    margin-bottom: 6px;\n    visibility: hidden;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 3px;\n    height: 12px;\n    margin-bottom: 6px;\n    white-space: nowrap;\n    border-radius: 10px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 3px;\n    height: 12px;\n    margin-bottom: 6px;\n    white-space: nowrap;\n    border-radius: 10px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 3px;\n    height: 12px;\n    margin-bottom: 6px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", " {\n              height: 16px;\n              -webkit-line-clamp: 1;\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled, { css } from 'styled-components';
import { Breakpoints } from "../../../theme";
import { mediaSmDown } from "../../../theme/helpers/media";
import colors from "../../../colors";
import NotAvailableBadge from "./NotAvailableBadge";
import Image from "./Image";
import { ImageSizes } from "../theme";
import { PRODUCT_NAME_TEST_ID } from "../constants";
import Box from "../../Grid/Box";
import Flex from "../../Grid/Flex";
import { EnumProductStates } from "../types";
import { ProductName } from "./Name";
import { ImageWrapper } from "../styled";
import { ProductPrice } from "./ProductPrice";
import UnitInfo from "./UnitInfo";
var TextContainer = styled.div.withConfig({
  displayName: "GridCardProductInfo__TextContainer",
  componentId: "sc-145a9fb-0"
})(["", ""], function (_ref) {
  var state = _ref.state;

  switch (state) {
    case EnumProductStates.notAvailable:
      return 'opacity: 0.5;';

    case EnumProductStates.inBasket:
      return css(["", ""], mediaSmDown(_templateObject(), ProductName));

    default:
      break;
  }
});
var BlocksContainer = styled(Flex).withConfig({
  displayName: "GridCardProductInfo__BlocksContainer",
  componentId: "sc-145a9fb-1"
})(["justify-content:flex-start;align-items:center;margin-bottom:9px;height:16px;flex-direction:row;", ""], mediaSmDown(_templateObject2()));
var StockBlock = styled(Flex).attrs({
  center: true,
  middle: true
}).withConfig({
  displayName: "GridCardProductInfo__StockBlock",
  componentId: "sc-145a9fb-2"
})(["", ";max-width:44px;height:16px;padding:1px 5px 2px 5px;background-color:", ";border-radius:20px;white-space:nowrap;", ""], function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["background-color:", " !important;"], colors.light200);
  }
}, colors.ghostWhite, mediaSmDown(_templateObject3()));
var SaleBlock = styled(Flex).attrs({
  center: true,
  middle: true
}).withConfig({
  displayName: "GridCardProductInfo__SaleBlock",
  componentId: "sc-145a9fb-3"
})(["", ";max-width:44px;height:16px;padding:1px 5px 2px 5px;background-color:", ";border-radius:20px;white-space:nowrap;margin-right:4px;", ""], function (_ref3) {
  var isKomus = _ref3.isKomus;

  if (isKomus) {
    return css(["background-color:", " !important;"], colors.primaryMain);
  }
}, colors.wildWatermelon, mediaSmDown(_templateObject4()));
var EmptyChip = styled.div.withConfig({
  displayName: "GridCardProductInfo__EmptyChip",
  componentId: "sc-145a9fb-4"
})(["height:16px;margin-bottom:9px;visibility:hidden;", ""], mediaSmDown(_templateObject5()));
var StockText = styled.span.withConfig({
  displayName: "GridCardProductInfo__StockText",
  componentId: "sc-145a9fb-5"
})(["", ";color:", ";opacity:50%;font-size:9px;font-weight:600;"], function (_ref4) {
  var isKomus = _ref4.isKomus;

  if (isKomus) {
    return css(["color:", " !important;"], colors.dark200);
  }
}, colors.blackRussian);
var SaleText = styled.span.withConfig({
  displayName: "GridCardProductInfo__SaleText",
  componentId: "sc-145a9fb-6"
})(["color:", ";font-size:9px;font-weight:600;"], colors.white);

var GridCardProductInfo = function GridCardProductInfo(_ref5) {
  var _product$image;

  var product = _ref5.product,
      state = _ref5.state,
      fullImage = _ref5.fullImage,
      isKomus = _ref5.isKomus;
  var name = product.name,
      available = product.available,
      sale = product.sale,
      type = product.type,
      old_price = product.old_price,
      price = product.price,
      price_per_kg = product.price_per_kg,
      item_weight = product.item_weight;
  var isNotAvailable = state === EnumProductStates.notAvailable || !available;

  var getFinalSale = function getFinalSale() {
    if (sale && old_price) {
      switch (type) {
        case 'weight':
          return "-".concat(100 - Math.floor(price_per_kg / old_price * 100), "%");

        case 'piece':
          return "-".concat(100 - Math.floor(price / old_price * 100), "%");

        default:
          return "-".concat(100 - Math.floor(price / (old_price * item_weight * 0.001) * 100), "%");
      }
    }
  };

  return React.createElement(React.Fragment, null, React.createElement(ImageWrapper, {
    withFullImage: fullImage
  }, React.createElement(Image, {
    size: fullImage ? ImageSizes.full : ImageSizes.big,
    src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.medium,
    disabled: isNotAvailable
  }), isNotAvailable && React.createElement(NotAvailableBadge, null)), React.createElement(BlocksContainer, null, sale && old_price ? React.createElement(SaleBlock, {
    isKomus: isKomus
  }, React.createElement(SaleText, null, getFinalSale())) : React.createElement(EmptyChip, null), product.stock ? React.createElement(StockBlock, {
    isKomus: isKomus
  }, React.createElement(StockText, {
    isKomus: isKomus
  }, product.stock > 99 ? 'Много' : "\u2248 ".concat(Math.ceil(product.stock), " ").concat(product.type === 'piece' ? 'шт' : 'кг'))) : React.createElement(EmptyChip, null)), React.createElement(TextContainer, {
    state: state
  }, React.createElement(Box, {
    hideBefore: Breakpoints.sm
  }, React.createElement(ProductPrice, {
    product: product,
    isKomus: isKomus
  })), React.createElement(Box, {
    mt: 1
  }, React.createElement(ProductName, {
    "data-testid": PRODUCT_NAME_TEST_ID,
    isKomus: isKomus
  }, name)), React.createElement(Box, {
    mt: {
      xs: 1,
      sm: 2
    }
  }, React.createElement(UnitInfo, {
    displayWeight: product.display_weight,
    productType: product.type,
    pricePerUnit: product.price_per_kg,
    hidePricePerUnit: product.hide_price_per_kg,
    unit: product.unit_in_price_per_kg,
    isKomus: isKomus
  }))));
};

export default GridCardProductInfo;